// extracted by mini-css-extract-plugin
export default {"strip":"ContactStrip_strip__-dzMc","label":"ContactStrip_label__KI0Br","email":"ContactStrip_email__GyXHe","dark":"ContactStrip_dark__BeDLW","light":"ContactStrip_light__-1vnl"};